import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { getFirebase } from 'react-redux-firebase';

const Logout = () => {
  const navigate = useNavigate();
  const firebase = getFirebase();

  useEffect(() => {
    firebase.auth().signOut().then(() => {
      navigate('/');
    });
  }, [firebase, navigate]);

  return null; // or a spinner if you want to show something
};

export default Logout;
